<template>
  <div class="search-bar"
    v-if="searchList.length>0">
    <div class="flex-row top-bar">
      <span :class="iconClass">&nbsp;&nbsp; {{ $t(titleName)}}</span>
      <div class="flex-row"
        v-if="showDetail">
        <span class="iconfont iconup-chevron-outline"
          v-show="showMore"
          @click="showMorDetail">&nbsp;&nbsp; {{$t('common.shrink')}}</span>
        <span class="iconfont  icondown-chevron-outline"
          v-show="!showMore"
          @click="showMorDetail">&nbsp;&nbsp; {{$t('common.viewMore')}}</span>
      </div>
    </div>
    <van-grid :gutter="10"
      column-num="3">
      <van-grid-item v-for="item in showList"
        :key="item.id"
        :clickable="true"
        @click="search(item)"
        :text="item.name" />
    </van-grid>
  </div>
</template>

<script>
import webService from "@/network/webService";
import _ from "lodash";
import commonjs from "@/common/common";
import storejs from '@common/store.js';
export default {
  name: "SearchTypeItem",
  props: ["searchType"],
  components: {},
  data () {
    return {
      searchList: [],
      showList: [],
      titleName: "",
      iconClass: "",
      showMore: false,
      showDetail: false,
    };
  },
  created () {
    this.iconClass = "iconfont icongrow-revenue-outline";
    if (this.searchType == commonjs.commonInfoEnmus.OrgStage) {
      this.iconClass = "iconfont icongrow-revenue-outline";
    }
    if (this.searchType == commonjs.commonInfoEnmus.OrgIndustry) {
      this.iconClass = "iconfont icongrowth-outline";
    }
    if (this.searchType == commonjs.commonInfoEnmus.CompanyIndustry) {
      this.iconClass = "iconfont iconcapital-outline";
    }
    if (this.searchType == commonjs.commonInfoEnmus.CompanyRound) {
      this.iconClass = "iconfont icongrowth-outline";
    }
    if (this.searchType == commonjs.commonInfoEnmus.CompanyInvestmentDate) {
      this.iconClass = "iconfont iconcenter-map-outline";
    }
    if (this.searchType == commonjs.commonInfoEnmus.Title) {
      this.iconClass = "iconfont iconlocation-outline";
    }
    if (this.searchType == commonjs.commonInfoEnmus.RelationDeepth) {
      this.iconClass = "iconfont iconopeninnewwindow-outline";
    }
    this.titleName = "common." + this.searchType;
    this.loadData(this.searchType);
  },
  methods: {
    showMorDetail () {
      this.showMore = !this.showMore;
      if (!this.showMore) {
        this.showList = _.take(this.searchList, 6);
      } else {
        this.showList = this.searchList;
      }
    },
    loadData (typeString) {
      if (typeString) {
        var params = [this.searchType];
        //取行业的值
        if (
          this.searchType == commonjs.commonInfoEnmus.CompanyIndustry
        ) {
          params = ["orgIndustry"];
        }
        webService.getCommonData(params).then((res) => {
          res.data.forEach((m) => {
            m.checked = false;
          });
          this.searchList = _.orderBy(res.data, ["sort"], ["asc"]);
          if (this.searchList.length > 6) {
            this.showList = _.take(this.searchList, 6);
            this.showDetail = true;
          } else {
            this.showList = this.searchList;
            this.showDetail = false;
          }
        });
      }
    },
    search (item) {
      let searchList = null;
      if (this.searchType == commonjs.commonInfoEnmus.CompanyRound) {
        searchList = [item.code];
      } else if (
        this.searchType ==
        commonjs.commonInfoEnmus.CompanyInvestmentDate
      ) {
        searchList = item.code;
      } else {
        searchList = [item.name];
      }
      if (this.searchType == commonjs.commonInfoEnmus.OrgStage) {
        storejs.state.orgStage = item;
        storejs.state.orgIndustry = null;
      }
      if (this.searchType == commonjs.commonInfoEnmus.OrgIndustry) {
        storejs.state.orgIndustry = item;
        storejs.state.orgStage = null;
      }
      if (this.searchType == commonjs.commonInfoEnmus.CompanyIndustry) {
        storejs.state.companyIndustry = item;
        storejs.state.companyRound = null;
        storejs.state.companyInvestmentDate = null;
      }
      if (this.searchType == commonjs.commonInfoEnmus.CompanyRound) {
        storejs.state.companyIndustry = null;
        storejs.state.companyRound = item;
        storejs.state.companyInvestmentDate = null;
      }
      if (this.searchType == commonjs.commonInfoEnmus.CompanyInvestmentDate) {
        storejs.state.companyIndustry = null;
        storejs.state.companyRound = null;
        storejs.state.companyInvestmentDate = item;
      }
      this.$emit("typeClick", this.searchType, searchList);
    },
  },
};
</script>


<style lang="scss" scoped>
.search-bar {
  //height: 100%;
  padding-bottom: 1rem;
}
.top-bar {
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;
  color: #504e4e;
}
.title {
  font-size: 14px;
  font-weight: 600;
}
/deep/ .van-grid-item__content {
  padding: 4px 4px;
  background-color: #f2f2f2;
  border: 1px solid #dedede;
}
/deep/ .van-grid-item__text {
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #7d7d7d;
}
.active {
  /deep/ .van-grid-item__text {
    color: #f15907;
  }
  /deep/ .van-grid-item__content {
    background-color: #f4e5e5;
    border: 1px solid #f15907;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/SearchTypeItem.vue